<style scoped lang="scss">
  .reload-cache {
    color: $theme-text-legacy;
  }
  .el-menu {
    border: none;
  }
  .menu-warp {
    height: 100%;
  }
  .menu-scroll {
    overflow: hidden;
    width: 125px;
  }
  .primary-nav .el-menu { background: $theme-nav-bg; }
  .primary-nav {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    height: 100%;
    background: $theme-nav-bg;
    .brand { position: static; width: 125px; height: 100px; }
    .menu { flex: 1; min-height: 0; height: auto; padding-top: 0; margin-right: 0; overflow-y: auto; scrollbar-width: thin; }
  }
  .sidebar-account { flex-shrink: 0; padding: 10px 8px; border-top: 1px solid $theme-nav-divider; }
  .account-trigger {
    display: flex; align-items: center; gap: 6px; width: 109px; min-height: 40px;
    padding: 4px 8px; border-radius: 4px; color: $theme-nav-muted; background: transparent; cursor: pointer;
    &:hover, &[aria-expanded="true"] { color: $theme-nav-text; background: $theme-nav-hover-overlay; }
    &:focus-visible { outline: 2px solid $theme-brand-accent; outline-offset: 1px; }
  }
  .account-icon { width: 16px; flex-shrink: 0; color: inherit; font-size: 16px; line-height: 20px; text-align: center; }
  .account-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: left; font-size: 12px; }
  .account-arrow { font-size: 10px; flex-shrink: 0; }
  .menu {
    height: 100%;
    padding-top: 100px;
    padding-bottom: 16px;
    box-sizing: border-box;
    overflow-y: overlay;
    overflow-x: hidden;
    margin-right: -15px;
    background: $theme-nav-bg;
    .el-menu-item {
      height: 45px;
      line-height: 45px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 16px !important;
      color: $theme-nav-text !important;
      &:hover, &:focus { background: $theme-nav-hover !important; }
      &.is-active {
        background: $theme-nav-selected !important;
        font-weight: 600;
        i { color: $theme-nav-active-icon; }
        &::before {
          position: absolute;
          left: 0;
          top: 13px;
          bottom: 13px;
          width: 3px;
          background: $theme-nav-indicator;
          content: '';
        }
      }
      i {
        display: inline-block;
        flex-shrink: 0;
        width: 18px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        margin: 0;
        color: $theme-nav-muted;
      }
    }
  }
  .secondary-nav, .sub-menu, .sub-menu .el-menu { background: $theme-nav-secondary-bg; }
  .secondary-nav { flex: 0 0 125px; min-width: 0; }
  .sub-menu {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    margin-right: 0;
    scrollbar-width: thin;
    border-right: 1px solid $theme-border;
    padding: 10px 0;
    .el-menu-item {
      width: 100%;
      min-width: 0;
      min-height: 38px;
      height: auto;
      padding: 9px 20px !important;
      line-height: 20px;
      white-space: normal;
      overflow-wrap: anywhere;
      &:hover, &:focus { background: $theme-nav-secondary-hover !important; color: $theme-nav-bg !important; }
      &.is-active {
        background: $theme-primary-selected !important;
        color: $theme-nav-secondary-text !important;
        font-weight: 600;
        &::before {
          position: absolute;
          left: 0;
          top: 10px;
          bottom: 10px;
          width: 3px;
          background: $theme-nav-secondary-indicator;
          content: '';
        }
      }
    }
  }
  .el-menu-item-group {
    padding-bottom: 20px;
  }
  .menu-group {
    &::after { content: none; }
  }
</style>

<style lang="scss">
  .sidebar-account-menu {
    padding: 6px;
    .account-menu-heading { padding: 10px 12px; border-bottom: 1px solid $theme-border-soft; margin-bottom: 5px; }
    .account-menu-heading strong { display: block; color: $theme-text-primary; overflow-wrap: anywhere; }
    .account-menu-heading span { color: $theme-text-secondary; font-size: 12px; }
    .account-menu-item {
      display: flex; align-items: center; gap: 10px; width: 100%; padding: 10px 12px;
      color: $theme-text-regular; background: $theme-surface; text-align: left; border-radius: 4px; font-size: 13px; cursor: pointer;
      &:hover, &:focus-visible { background: $theme-primary-soft; color: $theme-text-primary; }
      &:focus-visible { outline: 2px solid $theme-primary-text; outline-offset: -2px; }
    }
    .account-menu-logout { color: $theme-danger; border-top: 1px solid $theme-border-soft; margin-top: 5px; border-radius: 0; }
  }

  .order-num {
    padding-bottom: 5px;
    font-size: 16px;
    i {
      cursor: pointer;
    }
  }
  .order-store {
    color: $theme-text-legacy-muted;
  }
  .order-time {
    color: $theme-text-legacy-muted;
  }
  .secondary-nav .sub-menu {
    .el-menu-item-group__title {
      margin-top: 10px;
      padding: 7px 20px 5px;
      color: $theme-nav-group-text;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
    }
  }
  .height-content{
    height: 100%;;
  }
</style>

<template>
  <el-container>
    <!--左侧菜单开始-->
    <el-aside class="aside" :class="{'no-sub': $route.meta && $route.meta.hideMenu}">
      <div class="menu-warp view-flex">
        <div class="menu-scroll primary-nav">
          <router-link class="brand" :to="{path: path_prefixes ? '/' + path_prefixes : '/'}">
            <img src="../../static/img/image/logo-2.png" alt="美好活法">
          </router-link>
          <div class="menu">
            <el-menu :default-active="$route.matched[0].path ? $route.matched[0].path : $route.matched[1].path" text-color="var(--admin-nav-text)" active-text-color="var(--admin-nav-text)" @select="handleChange">
              <el-menu-item v-for="(item, index) in $router.options.routes" :key="index" v-if="!item.hidden" :index="item.path" @click="toRoute(item.path)" >
                <i class="iconfont" :class="'iconfont icon-' + item.iconCls"></i> {{item.name}}
              </el-menu-item>
            </el-menu>
          </div>
          <div class="sidebar-account">
            <el-popover placement="right-end" trigger="click" :width="230" popper-class="sidebar-account-menu" v-model="visible2">
              <div class="account-menu-heading">
                <strong>{{ nick_name || name || '当前账号' }}</strong>
                <span>账号管理</span>
              </div>
              <button type="button" class="account-menu-item" @click="visible2 = false; handleUserInfo()"><i class="el-icon-user"></i>基础信息</button>
              <button v-if="$store.getters.login_type === 'distributor'" type="button" class="account-menu-item" @click="visible2 = false; handleClickSelectShop()"><i class="el-icon-office-building"></i>切换店铺</button>
              <button type="button" class="account-menu-item" @click="visible2 = false; reloadCache()"><i class="el-icon-refresh"></i>刷新首页缓存</button>
              <button type="button" class="account-menu-item account-menu-logout" @click="visible2 = false; logout()"><i class="el-icon-switch-button"></i>退出登录</button>
              <button slot="reference" type="button" class="account-trigger" :title="nick_name || name || '账号菜单'" :aria-label="(nick_name || name || '当前账号') + '，账号菜单'" aria-haspopup="true" :aria-expanded="visible2 ? 'true' : 'false'">
                <i class="account-icon el-icon-user" aria-hidden="true"></i>
                <span class="account-name">{{ nick_name || name || '当前账号' }}</span>
                <i :class="visible2 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" class="account-arrow" aria-hidden="true"></i>
              </button>
            </el-popover>
          </div>
        </div>
        <template v-if="$route.meta && !$route.meta.hideMenu">
          <div class="menu-scroll secondary-nav" v-for="(item,index) in $router.options.routes" v-if="isCurrentSubmenu(item.path)">
            <el-menu :default-active="$route.matched.length > 3 ? $route.matched[$route.matched.length-2].path : $route.path" class="sub-menu" background-color="#f5f6f8" text-color="var(--admin-text-regular)" active-text-color="var(--admin-text-primary)" router>
              <template v-for="(child, index) in item.children" v-if="!child.hidden">
                <el-menu-item-group v-if="child.isLeaf" class="menu-group">
                  <template slot="title">{{child.name}}</template>
                  <template v-for="(sub, index) in child.children">
                    <el-menu-item :key="sub.path" :index="sub.path" v-if="!sub.hidden">{{sub.name}}</el-menu-item>
                  </template>
                </el-menu-item-group>
                <div v-else class="menu-group">
                  <el-menu-item :index="child.path">{{child.name}}</el-menu-item>
                </div>
              </template>
            </el-menu>
          </div>
        </template>
      </div>
    </el-aside>
    <el-container>
      <el-main>
        <section id="container" class="content-container height-content">
          <el-col :span="24" class="content-wrapper height-content">
            <transition name="fade" mode="out-in" class="height-content">
              <router-view class="height-content"></router-view>
            </transition>
          </el-col>
        </section>
      </el-main>
    </el-container>

    <!--基础信息弹窗-->
    <el-dialog
      title="管理员信息"
      :visible.sync="dialogBaseInfo"
      width="40%"
      :before-close="handleBaseInfoClose"
    >
      <el-form ref="form" :model="form" label-position="left" label-width="100px">
        <div class="section-body">
          <el-form-item label="账户">
            {{ form.mobile }}
          </el-form-item>
          <el-form-item label="昵称">
            <el-input type="text" v-model="form.username" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="大头照">
            <imgBox :imgUrl="form.head_portrait" inline @click="handleImgChange"></imgBox>
            <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
          </el-form-item>

          <template v-if="change_pwd">
            <el-form-item label="修改密码">
              <el-input :type="new_input_type" v-model="form.pwd" style="width:300px" placeholder="请输入新密码">
                <i slot="suffix" title="隐藏密码" @click="changeNewPass" style="cursor:pointer;"
                   class="el-icon-view"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="确认修改密码">
              <el-input :type="input_type" v-model="form.repwd" style="width:300px" placeholder="请输入确认密码">
                <i slot="suffix" title="隐藏密码" @click="changePass" style="cursor:pointer;"
                   class="el-icon-view"></i>
              </el-input>
            </el-form-item>
          </template>
        </div>
        <div class="section-footer content-center">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-container>
</template>
<script>
  import { reloadCache, getAdminInfo, updateAdminInfo } from "../api/login";
  import { mapGetters } from 'vuex'
  import imgPicker from '@/components/imageselect'
  import imgBox from '@/components/element/imgBox'
  import store from '../store'
  export default {
    components: {
      imgPicker,
      imgBox
    },
    data () {
      return {
        isShowAside: 'false',
        findMenu: false,
        menusList: [],
        homeIndex: '',
        activeIndex: '',
        visible2: false,
        isCurrentSubmenu: function (path) {
          const homePath = this.path_prefixes ? `/${this.path_prefixes}` : '/'
          if (path.indexOf('/shopadmin') !== -1) {
            return path.split('/')[2] == this.$route.path.split('/')[2]
          }

          if (path !== homePath) {
            if (this.path_prefixes) {
              return path.split('/')[2] == this.$route.path.split('/')[2]
            } else {
              return path.split('/')[1] == this.$route.path.split('/')[1]
            }
          }
        },
        dialogBaseInfo: false,
        form: {
          username: '',
          head_portrait: '',
          pwd:'',
          repwd:'',
          logintype:''
        },
        imgDialog: false,
        isGetImage: false,
        input_type: "password",
        new_input_type: "password",
        change_pwd: false,
      }
    },
    computed: {
      ...mapGetters([
        'name',
        'nick_name',
        'avatar',
        'wxapp_id',
        'template_name'
      ])
    },
    methods: {
      handleClickSelectShop(){
        this.$router.push({path: this.path_prefixes ? `/${this.path_prefixes}/shopadmin/shoplist` : '/shopadmin/shoplist'})
      },
      handleChange (key) {
        this.activeIndex = key
      },
      handleUserInfo () {
        /*this.$router.push({
          path: this.matchInternalRoute('admininfo')
        })*/
        getAdminInfo().then(res => {
          this.change_pwd = res.data.data.logintype != 'admin'
          this.form = res.data.data
          this.dialogBaseInfo = true
        })
      },
      toRoute (path) {
        this.$router.push({
          path: path
        })
      },
      logout: function () {
         this.$confirm('确定退出登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('unsetToken').then(() => {
            this.$router.push({ path: this.path_prefixes ? `/${this.path_prefixes}/login` : `/login` })
            this.$router.go(0)
          })
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消登录'
          });
        });

        // this.$store.dispatch('unsetToken').then(() => {
        //   this.$router.push({ path: this.path_prefixes ? `/${this.path_prefixes}/login` : `/login` })
        // })
      },
      reloadCache() {
        reloadCache().then(res => {
          this.$message.success('刷新成功')
        })
      },
      handleBaseInfoClose() {
        this.dialogBaseInfo = false
      },
      handleImgChange () {
        this.imgDialog = true
        this.isGetImage = true
      },
      pickImg (data) {
        this.form.head_portrait = data.url
        this.imgDialog = false
      },
      closeImgDialog () {
        this.imgDialog = false
      },
      onSubmit () {
        const that = this
        updateAdminInfo(this.form).then(response => {
          if(response.data.data) {
            this.$message({
              message: '更新成功',
              type: 'success',
              onClose(){
                that.dialogBaseInfo = false
              }
            })
          }
        })
      },
      changeNewPass(){
        this.new_input_type = (this.new_input_type == 'text') ? 'password' : 'text'
      },
      changePass(){
        this.input_type = (this.input_type == 'text') ? 'password' : 'text'
      },
    },
    mounted () {
      this.activeIndex = this.$route.meta.sn
    }
  }
</script>



// WEBPACK FOOTER //
// layout.vue?2983b1dc